import React from 'react';
import Icon from '../../../components/AppIcon';

const MetricsCard = ({ title, value, change, changeType, icon, description }) => {
  const getChangeColor = (type) => {
    switch (type) {
      case 'positive':
        return 'text-success';
      case 'negative':
        return 'text-error';
      case 'neutral':
        return 'text-muted-foreground';
      default:
        return 'text-muted-foreground';
    }
  };

  const getChangeIcon = (type) => {
    switch (type) {
      case 'positive':
        return 'TrendingUp';
      case 'negative':
        return 'TrendingDown';
      case 'neutral':
        return 'Minus';
      default:
        return 'Minus';
    }
  };

  const getChangeBackground = (type) => {
    switch (type) {
      case 'positive':
        return 'bg-success/10 border-success/30';
      case 'negative':
        return 'bg-error/10 border-error/30';
      case 'neutral':
        return 'bg-muted/10 border-muted/30';
      default:
        return 'bg-muted/10 border-muted/30';
    }
  };

  return (
    <div className="bg-gradient-to-br from-card to-card/80 border border-border rounded-lg p-6 elevation-1 hover:elevation-2 transition-luxury hover:shadow-lg">
      <div className="flex items-center justify-between mb-4">
        <div className="w-14 h-14 bg-gradient-to-br from-accent/20 to-accent/10 border border-accent/30 rounded-xl flex items-center justify-center shadow-sm">
          <Icon name={icon} size={28} className="text-accent" />
        </div>
        {change && (
          <div className={`flex items-center space-x-1 px-3 py-1 rounded-full border ${getChangeBackground(changeType)} ${getChangeColor(changeType)}`}>
            <Icon name={getChangeIcon(changeType)} size={14} />
            <span className="text-sm font-bold">{change}</span>
          </div>
        )}
      </div>
      
      <div className="mb-3">
        <h3 className="text-3xl font-heading text-foreground mb-2 bg-gradient-to-r from-foreground to-foreground/80 bg-clip-text">{value}</h3>
        <p className="text-sm font-medium text-muted-foreground">{title}</p>
      </div>
      
      {description && (
        <div className="bg-muted/20 border border-muted/40 rounded-lg p-2">
          <p className="text-xs text-foreground/70 font-medium">{description}</p>
        </div>
      )}
    </div>
  );
};

export default MetricsCard;